import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchNickName } from '../../api/fetchers/nickName/fetcher';
import type { FetchNickNameParams } from '../../api/fetchers/nickName/types';

export const fetchNickNameAction = createAsyncThunk('player/fetchNickName', (params: FetchNickNameParams) =>
  fetchNickName(params)
);
